<template>
  <div class="wallpaper-stats">
    <h3>壁纸统计分析</h3>

    <div class="filter-bar">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
        :shortcuts="shortcuts"
        :disabled-date="disabledDate"
        class="date-picker"
      />
      <div class="filter-group">
        <span class="filter-label">设备类型:</span>
        <el-select v-model="deviceType" placeholder="设备类型" clearable filterable>
          <el-option label="All" value="All" />
          <el-option v-for="item in deviceTypes" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="filter-group">
        <span class="filter-label">国家:</span>
        <el-select v-model="country" placeholder="国家" clearable filterable>
          <el-option label="All" value="All" />
          <el-option v-for="item in countries" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="filter-group">
        <span class="filter-label">广告系列ID:</span>
        <el-select v-model="campaignId" placeholder="广告系列ID" clearable filterable>
          <el-option label="All" value="All" />
          <el-option v-for="item in campaignIds" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="filter-group">
        <span class="filter-label">广告系列:</span>
        <el-select v-model="campaignName" placeholder="广告系列" clearable filterable>
          <el-option label="All" value="All" />
          <el-option v-for="item in campaignNames" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="filter-group">
        <span class="filter-label">广告组ID:</span>
        <el-select v-model="adGroupId" placeholder="广告组ID" clearable filterable>
          <el-option label="All" value="All" />
          <el-option v-for="item in adGroupIds" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <div class="filter-group">
        <span class="filter-label">广告组:</span>
        <el-select v-model="adGroupName" placeholder="广告组" clearable filterable>
          <el-option label="All" value="All" />
          <el-option v-for="item in adGroupNames" :key="item" :label="item" :value="item" />
        </el-select>
      </div>
      <el-button type="primary" @click="fetchData" :loading="loading">查询</el-button>
    </div>
    <div style="color: #E63D3D; font-size: 12px; margin-bottom: 10px;">
      注：GA4 数据存在 72 小时更新窗口，事件表每日导出、隔天17点才创建（每天17点30分定时任务更新）。定时任务更新近3天数据，按当前量级（约2.3万）预计有2%-3%的数据差异。事件表仅从开通BigQuery每日导出后（5月12日）开始有数据。
    </div>
    <div style="color: #999; font-size: 12px; margin-bottom: 10px;">
      Apply率 = Apply次数 / 预览次数；Succ率 = 成功次数 / Apply次数
    </div>

    <el-tabs v-model="activeTab" type="border-card" v-loading="loading">
      <el-tab-pane label="壁纸分类热度榜" name="category">
        <el-table :data="categoryData" stripe border :loading="loading">
          <el-table-column prop="category" label="分类" width="120" />
          <el-table-column prop="category_type" label="类型" width="100" />
          <el-table-column prop="preview_count" label="预览PV" width="100" sortable />
          <el-table-column prop="preview_count_uv" label="预览UV" width="100" sortable />
          <el-table-column prop="apply_count" label="ApplyPV" width="100" sortable />
          <el-table-column prop="apply_count_uv" label="ApplyUV" width="100" sortable />
          <el-table-column prop="succ_count" label="成功PV" width="100" sortable />
          <el-table-column prop="succ_count_uv" label="成功UV" width="100" sortable />
          <el-table-column prop="apply_rate" label="Apply率(PV)" width="100">
            <template #default="scope">
              {{ scope.row.apply_rate }}%
            </template>
          </el-table-column>
          <el-table-column prop="apply_rate_uv" label="Apply率(UV)" width="100">
            <template #default="scope">
              {{ scope.row.apply_rate_uv }}%
            </template>
          </el-table-column>
          <el-table-column prop="succ_rate" label="Succ率(PV)" width="100">
            <template #default="scope">
              {{ scope.row.succ_rate }}%
            </template>
          </el-table-column>
          <el-table-column prop="succ_rate_uv" label="Succ率(UV)" width="100">
            <template #default="scope">
              {{ scope.row.succ_rate_uv }}%
            </template>
          </el-table-column>
          <el-table-column prop="avg_preview" label="人均预览" width="90" />
          <el-table-column prop="avg_apply" label="人均Apply" width="90" sortable />
          <el-table-column prop="avg_succ" label="人均成功" width="90" />
        </el-table>
      </el-tab-pane>

      <el-tab-pane label="具体壁纸热度Top20" name="wallpaper">
        <el-table :data="wallpaperData" stripe border :loading="loading">
          <el-table-column prop="resource_id" label="壁纸ID" width="150">
            <template #default="scope">
              <el-tooltip
                v-if="scope.row.resource_url"
                placement="top"
                effect="light"
              >
                <template #content>
                  <video
                    v-if="scope.row.resource_url.includes('.mp4')"
                    :src="scope.row.resource_url"
                    controls
                    style="max-width: 200px; max-height: 300px;"
                  />
                  <img
                    v-else
                    :src="scope.row.resource_url"
                    style="max-width: 200px; max-height: 300px;"
                  />
                </template>
                <a href="javascript:void(0)" @click.prevent="openUrl(scope.row.resource_url)" style="color: #409EFF;">
                  {{ scope.row.resource_id }}
                </a>
              </el-tooltip>
              <span v-else>{{ scope.row.resource_id }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="category" label="分类" width="120" />
          <el-table-column prop="category_type" label="类型" width="100" />
          <el-table-column prop="preview_count" label="预览PV" width="100" sortable />
          <el-table-column prop="preview_count_uv" label="预览UV" width="100" sortable />
          <el-table-column prop="apply_count" label="ApplyPV" width="100" sortable />
          <el-table-column prop="apply_count_uv" label="ApplyUV" width="100" sortable />
          <el-table-column prop="succ_count" label="成功PV" width="100" sortable />
          <el-table-column prop="succ_count_uv" label="成功UV" width="100" sortable />
          <el-table-column prop="apply_rate" label="Apply率(PV)" width="100">
            <template #default="scope">
              {{ scope.row.apply_rate }}%
            </template>
          </el-table-column>
          <el-table-column prop="apply_rate_uv" label="Apply率(UV)" width="100">
            <template #default="scope">
              {{ scope.row.apply_rate_uv }}%
            </template>
          </el-table-column>
          <el-table-column prop="succ_rate" label="Succ率(PV)" width="100">
            <template #default="scope">
              {{ scope.row.succ_rate }}%
            </template>
          </el-table-column>
          <el-table-column prop="succ_rate_uv" label="Succ率(UV)" width="100">
            <template #default="scope">
              {{ scope.row.succ_rate_uv }}%
            </template>
          </el-table-column>
          <el-table-column prop="avg_preview" label="人均预览" width="90" />
          <el-table-column prop="avg_apply" label="人均Apply" width="90" sortable />
          <el-table-column prop="avg_succ" label="人均成功" width="90" />
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { get_wallpaper_stats, get_wallpaper_config } from '../services/requests'
import { ElMessage } from 'element-plus'

const minDate = new Date('2026-05-12')

// 定时任务UTC时间9:30，即北京时间17:30
// 9点30前最大日期为前2天，9点30后最大日期为前1天
const TASK_HOUR_UTC = 9
const TASK_MINUTE = 30

function isAfterTaskTime() {
  const now = new Date()
  const utcHour = now.getUTCHours()
  const utcMinute = now.getUTCMinutes()
  const currentUtcMinutes = utcHour * 60 + utcMinute
  const taskUtcMinutes = TASK_HOUR_UTC * 60 + TASK_MINUTE
  return currentUtcMinutes >= taskUtcMinutes
}

const maxDate = computed(() => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const offset = isAfterTaskTime() ? 1 : 2
  const max = new Date(today)
  max.setDate(max.getDate() - offset)
  return max
})

const yesterday = computed(() => {
  return new Date(maxDate.value)
})

const defaultStart = computed(() => {
  const start = new Date(yesterday.value)
  start.setDate(start.getDate() - 6)
  if (start < minDate) {
    return new Date(minDate)
  }
  return start
})

const formatDate = (d) => {
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const dateRange = ref([formatDate(defaultStart.value), formatDate(yesterday.value)])
const activeTab = ref('category')
const loading = ref(false)
const categoryData = ref([])
const wallpaperData = ref([])
const deviceType = ref('All')
const country = ref('All')
const deviceTypes = ref([])
const countries = ref([])
const campaignIds = ref([])
const campaignNames = ref([])
const adGroupIds = ref([])
const adGroupNames = ref([])
const campaignId = ref('All')
const campaignName = ref('All')
const adGroupId = ref('All')
const adGroupName = ref('All')

async function fetchConfig() {
  try {
    const res = await get_wallpaper_config()
    if (res.data.code === 200) {
      deviceTypes.value = res.data.data.device_categories || []
      countries.value = res.data.data.countries || []
      campaignIds.value = res.data.data.campaign_ids || []
      campaignNames.value = res.data.data.campaign_names || []
      adGroupIds.value = res.data.data.ad_group_ids || []
      adGroupNames.value = res.data.data.ad_group_names || []
    }
  } catch (e) {
    console.error('获取壁纸配置异常:', e)
  }
}

onMounted(() => {
  fetchConfig()
})

const shortcuts = computed(() => {
  const end = new Date(yesterday.value)
  return [
    {
      text: '最近7天',
      value: () => {
        const start = new Date(end)
        start.setDate(start.getDate() - 6)
        if (start < minDate) {
          start.setTime(minDate.getTime())
        }
        return [start, end]
      },
    },
    {
      text: '最近3天',
      value: () => {
        const start = new Date(end)
        start.setDate(start.getDate() - 2)
        if (start < minDate) {
          start.setTime(minDate.getTime())
        }
        return [start, end]
      },
    },
    {
      text: '昨天',
      value: () => {
        const start = new Date(end)
        return [start, end]
      },
    },
  ]
})

function disabledDate(date) {
  const minDateStart = new Date(minDate)
  minDateStart.setHours(0, 0, 0, 0)
  return date < minDateStart || date > maxDate.value
}

async function fetchData() {
  if (!dateRange.value || dateRange.value.length < 2) {
    ElMessage.warning('请选择日期范围')
    return
  }

  loading.value = true
  try {
    const params = {
      start_date: dateRange.value[0],
      end_date: dateRange.value[1],
      device_type: deviceType.value,
      country: country.value,
      campaign_id: campaignId.value,
      campaign_name: campaignName.value,
      ad_group_id: adGroupId.value,
      ad_group_name: adGroupName.value
    }
    const res = await get_wallpaper_stats(params)
    if (res.data.code === 200) {
      categoryData.value = res.data.data.category_stats || []
      wallpaperData.value = res.data.data.wallpaper_stats || []
    } else {
      ElMessage.error(res.data.message || '获取数据失败')
    }
  } catch (e) {
    ElMessage.error('请求异常: ' + e.message)
  } finally {
    loading.value = false
  }
}

function openUrl(url) {
  window.open(url, '_blank')
}
</script>

<style scoped>
.wallpaper-stats {
  padding: 20px;
}

.filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
}

.date-picker {
  flex-shrink: 0;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.filter-label {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

.filter-group :deep(.el-select) {
  width: 130px;
}
</style>